import type { CellContext } from '@tanstack/react-table';
import { type ChangeEvent, useEffect, useState } from 'react';
import Input from '@/components/UI/Form/Input';

const EditableCell = (info: CellContext<any, any>) => {
  const initialValue = info.getValue();
  const { index } = info.row;
  const { id } = info.column;
  const { updateTableData, editableRowIndex } = info.table.options.meta as any;
  // We need to keep and update the state of the cell normally
  const [value, setValue] = useState(initialValue);

  const onChange = (e: ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    setValue(e.target.value);
  };

  // We'll only update the external data when the input is blurred
  const onBlur = () => {
    updateTableData?.(index, id, value);
  };

  // If the initialValue is changed externally, sync it up with our state
  useEffect(() => {
    setValue(initialValue);
  }, [initialValue]);

  return index === editableRowIndex ? (
    <Input type='text' name={id} value={value} placeholder='e.g. Sage Office' changed={onChange} onBlur={onBlur} required />
  ) : (
    <p>{value}</p>
  );
};

export default EditableCell;
